export class UserLayoutListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            requiredField: lang.general[26],
            save: lang.general[0],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            exportPrint: lang.general[16],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            additionalColumns: lang.general[12],
            validEmail: lang.general[73],
            submit: lang.general[37],
            enterStartdate: lang.general[80],
            lastAccess: lang.general[90],
            settings: lang.general[91],
            logout: lang.general[92],
            registry: lang.general[93],
            supplyers: lang.general[94],
            privacy: lang.general[113],
            treatment_register: lang.general[114],
            appointment_data_processfor: lang.general[115],
            informative: lang.general[116],
            suppliers: lang.general[118],
            calendar: lang.general[119],
        }

    }

    lang() {
        return this.variables;
    }

}

